/**
 * サンプルクラス
 * @constructor
 */
class Accordion {
  constructor() {

  }
  /**
   * サンプル
   */
  init() {
    $('#j-accordionBtn').on('click', (e) => {
      $(e.currentTarget).toggleClass('is-active');
      $('.p-asahiwrap__tableContInner').toggleClass('is-active');
    });
  }
};

export default Accordion;
